import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=68bd3c6c&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./batchNumberDetail.vue?vue&type=style&index=0&id=68bd3c6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd3c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bd3c6c')) {
      api.createRecord('68bd3c6c', component.options)
    } else {
      api.reload('68bd3c6c', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=68bd3c6c&scoped=true", function () {
      api.rerender('68bd3c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/branchAccounts/cmp/batchNumberDetail.vue"
export default component.exports